import LandingAdvantage from '@/components/FeatureSection/LandingAdvantage';
import WhatOurCustomersAreSaying from '@/components/FeatureSection/WhatOurCustomersAreSaying';
import SlimFooter from '@/components/Footer/SlimFooter';
import LandingPageV1 from '@/components/LandingPage/LandingPageV1';
import { ReactElement } from 'react';

export default function Page() {
  return (
    <>
      <main>
        <LandingPageV1 cid="xxxx" name="Video Integration" banner={''} />;
      </main>
      <LandingAdvantage />
      <WhatOurCustomersAreSaying />
      <SlimFooter />
    </>
  );
}

Page.getLayout = function getLayout(page: ReactElement) {
  return <>{page}</>;
};
